import { clearCookies } from '@main/utils/cookies';
import type { BaseUsecase } from '@usecases/base-usecase';

export type UserLogoutUsecase = BaseUsecase<void, void>;

export interface UserLogoutAuthenticator {
  signOut(): Promise<void>;
}

export interface UserLogoutRepository {
  removeUserDetails(): Promise<void>;
}

export interface UserLogoutEventPublisher {
  removeNumberDetails(): Promise<void>;
}

export class UserLogout implements UserLogoutUsecase {
  constructor(
    private authenticator: UserLogoutAuthenticator,
    private repository: UserLogoutRepository,
    private publisher: UserLogoutEventPublisher,
  ) {}

  async run(): Promise<void> {
    await Promise.all([
      this.authenticator.signOut(),
      this.repository.removeUserDetails(),
      this.publisher.removeNumberDetails(),
      clearCookies(),
    ]);
  }
}
